<script>
  import { createEventDispatcher } from 'svelte';

  export let variant = 'solid'; // solid, outlined
  export let color = 'primary'; // primary, secondary
  export let size = 'medium'; // small, medium, large
  export let disabled = false;
  export let dataAttrs = {};
  export let customClass = '';
  export let style = '';
  const variantClasses = {
    solid: 'extra-btn-solid--{colorClass}',
    outlined: 'extra-btn-outlined--{colorClass}',
  };

  const sizeClasses = {
    small: 'btn-sm',
    medium: 'btn-md',
    large: 'btn-lg',
  };

  const colorClasses = {
    primary: 'color-primary',
    secondary: 'color-secondary',
  };

  let colorClass = colorClasses[color];
  let variantClass = variantClasses[variant] ? variantClasses[variant].replace(/{colorClass}/g, colorClass) : '';

  const dispatcher = createEventDispatcher();

  const onButtonClick = () => dispatcher('click', null);
</script>

<div class="extra-btn">
  <button
    class="btn {sizeClasses[size]} {variantClass} {customClass}"
    {disabled}
    {...dataAttrs}
    {style}
    on:click={onButtonClick}
  >
    <slot>
      <!-- Fallback content if no slot content provided -->
      <span>Button</span>
    </slot>
  </button>
</div>

<style lang="scss">
  @import '../styles/colors.new.scss';

  .extra-btn {
    // Common button styles
    button {
      box-shadow: none;
      outline: none;
      text-decoration: none;
      width: 100%;
      font-weight: 700;
      border-radius: 40px;

      &:disabled {
        background-color: $secondary-gray-02;
        color: $secondary-gray-01;
        cursor: default;
        pointer-events: none;
        opacity: 1px;
        border: none;
      }
    }

    // Button size mixins
    %button-base {
      font-size: 12px;
      line-height: 14px;

      @include desktop-min-width {
        font-size: 14px;
        line-height: 16px;
      }
    }

    .btn-sm {
      @extend %button-base;
      min-height: auto;
      padding: 7px 24.5px;
    }

    .btn-md {
      @extend %button-base;
      min-height: 36px;
      height: 100%;
      padding: 10px 24.5px;

      @include desktop-min-width {
        min-height: 48px;
      }
    }

    .btn-lg {
      font-size: 14px;
      line-height: 18px;
      min-height: 48px;
      padding: 10px 15px;

      @include desktop-min-width {
        font-size: 24px;
        line-height: 28px;
        min-height: 64px;
      }
    }

    // Button variants
    %button-solid {
      border-radius: 40px;
      &:hover,
      &:active {
        filter: brightness(90%);
        border-width: 1px;
      }
    }

    .extra-btn-solid--color-primary {
      @extend %button-solid;
      background-color: $primary-blue;
      color: $primary-white;
    }

    .extra-btn-solid--color-secondary {
      @extend %button-solid;
      background-color: $primary-yellow-01;
      color: $primary-black;
    }

    %button-outlined {
      @extend %button-solid;
      background-color: $primary-white;
      border-width: 1px;
      border-radius: 40px;

      &:hover,
      &:active {
        filter: brightness(90%);
        border-width: 1px;
        border-color: inherit;
        background-color: transparent;
      }
    }

    .extra-btn-outlined--color-primary {
      @extend %button-outlined;
      color: $primary-blue;
      border-color: $primary-blue;
    }

    .extra-btn-outlined--color-secondary {
      @extend %button-outlined;
      color: $primary-yellow-01;
      border-color: $primary-yellow-01;
    }
  }
</style>
